import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	connect() {
		const cookie = document.cookie
			.split('; ')
			.find((row) => row.startsWith('cookies_accepted='))
			?.split('=')[1];

		if (!cookie) {
			this.show();
		}
	}

	accept() {
    // Set cookie max age to 30 days
    const date = new Date();
    date.setDate(date.getDate() + 30);
    console.log(date.toUTCString());
		document.cookie = `cookies_accepted=yes; expires=${date.toUTCString()}; path=/`;
		this.hide();
	}

	show() {
		this.element.removeAttribute('hidden');
	}

	hide() {
		this.element.setAttribute('hidden', '');
	}
}
